import Vue from 'vue';
import CapitalMarketPublications from './capital-market-publications.vue';
Vue.component('capital-market-publications', CapitalMarketPublications);
